
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 20 20","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M15.4 2.9h-1.3V.6l-1-.6-8.3 2.8-.3.2-.6.6V19.4l.7.6h10.9l.7-.7V3.6l-.8-.7zm-5.4 0l2.4-.8V3L10 2.9zm4.4 1.7v13.7H5.6V4.6h8.8z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M7 12.7h6.1v1.7H7zM7 15.5h6v1.7H7z"}})])
          )
        }
      }
    